module.exports = __webpack_public_path__ + "static/media/2023.9.11_fairearth_brandmark_white.a95cf0b7.png";